import type { FaireProductEntity } from "../../entity_types/product";

export const p_c7pqjejj3s: FaireProductEntity = {
  token: "p_c7pqjejj3s",
  type: "product",
  name: "Hexagonal Diamond Cone Pendulum",
  brandToken: "b_pxpb5s3cxg",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/4bc99a4c2886b9412a0a4b096b08fbb79cfc0add0731c2e72354600d29be08e7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6ae8b6dfe905a4437d80a5ea81f167ff609a65e4ac1ef100fbfbd6f02d473233.jpeg",
    "https://cdn.faire.com/fastly/16d01a62f2fc05533e5fac788e6940e510e5a58cb442d737ce29367f0b01f0b4.jpeg",
    "https://cdn.faire.com/fastly/b4f1b0da9f29aae9e062a4e7c4a8079a8f84fd3a5413d04481f97de2de3b2b15.jpeg",
    "https://cdn.faire.com/fastly/ccc4d2cb20734341fb7b1c950b24a2e50b804c1c495e8fd11c5ee00bd8b2107c.jpeg",
    "https://cdn.faire.com/fastly/3e853d7f3ca504376efe2dd1d1a6b1fe87668db9bb90691a92449b594ab94c34.jpeg",
    "https://cdn.faire.com/fastly/e678db5202ab0c7e4f61b11210e719d90a88bc3c212c22d59f2427d5642b2e57.jpeg",
    "https://cdn.faire.com/fastly/75162d4b336e6dca6abd2e786677ce335763893988ad28fad0e937c66d2633b3.jpeg",
  ],
  priceDollars: 11.09,
  description:
    "Material:Hexagon shape natural crystal stone pendulum.\n\nSize:The pendulum pendant is 17x62mm.\n\nEffect: The stone Pendant is facets like crystal generator to promote clarity and concentration. The facets of stone will enhance the colour and enrich its own beauty. It is well polished to make you feel comfortable when it touch your skin.\n\n-ID: GEM-KS-P2417\n-Chain Length: 18cm(7inch)\n-Weight(s): 15g\n-Quality: Excellent\n-Lead Free, Nickel Free",
  tags: [],
  msrpDollars: 22.17,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:20.103Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
